

(function ($, App, Utils) {
  'use strict';

  var logger = new Logger('Focusable');

  Utils.add('Focusable', {

    Selectors: {
      focusableEl: 'a, button, :input, [tabindex]'
    },

    init: function () {
      /*
      * jQuery Focusable Selector
      * @author Danny Turcotte <turcottedanny@gmail.com>
      *
      * Usage: $('#my-container').find(':focusable');
      */

      jQuery.extend(jQuery.expr[':'], {
        focusable: function (el, index, selector) {
          return $(el).is(Utils.Focusable.Selectors.focusableEl);
        }
      });
    }
  });

})(jQuery, window.App, window.App.Utils);
